import React from "react";
import axios from 'axios';
import NextErrorComponent from 'next/error'
import {isEmpty} from "../components/helpers/helpers";
import ServerError from "./500";

const Error = ({statusCode, err}) => {

    if (!isEmpty(statusCode) && statusCode >= 500) {
        return <ServerError/>
    } else {
        return <NextErrorComponent statusCode={statusCode}/>
    }
};

Error.getInitialProps = async ({res, err, asPath}) => {
    const errorInitialProps = await NextErrorComponent.getInitialProps({
        res,
        err,
    });


    errorInitialProps.hasGetInitialPropsRun = true;

    if (err && !isEmpty(errorInitialProps.statusCode)) {
        let msg = `Status: ${errorInitialProps.statusCode} \n`;
        msg += `error: ` + `${err}` + `\n`;
        msg += 'path: [Click To Open](' + process.env.NEXT_PUBLIC_APP_URL + asPath + ') \n';

        const token = process.env.NEXT_PUBLIC_APP_TOKEN;
        let chatIds = process.env.NEXT_PUBLIC_APP_CHAT_IDS;

        if (!isEmpty(chatIds) && !isEmpty(token)) {
            chatIds = chatIds.split(',');

            for (let chat_id of chatIds) {
                const data = {
                    "chat_id": chat_id,
                    "text": msg,
                    "parse_mode": "markdown"
                };

                axios.post(`https://api.telegram.org/bot${token}/sendMessage`, data);
            }
        }
    }

    return errorInitialProps
};

export default Error